// ////////////////////
// AssistantCat Type Definitions
// ////////////////////

import { AssistWriterType, FeedbackManuscriptMode, GenerateSummaryMode } from "./assist";

/** アシスタント猫のグループタイプ */
export type AssistantCatGroup = "LA" | "LP" | "MA" | "MP";

/**
 * アシスタント猫マスタデータ
 * ユーザーが選択中のアシスタント猫と作家タイプを管理
 */
export interface AssistantCatMaster {
  /** ユーザーID */
  userId: string;
  /** 現在選択中のアシスタント猫タイプ */
  selectedType: AssistWriterType;
  /** 作家タイプ診断の結果 */
  writerType: AssistWriterType;
  /** アシスタント猫の感想モード */
  feedbackManuscriptMode: FeedbackManuscriptMode;
  /** アシスタント猫のあらすじモード */
  generateSummaryMode: GenerateSummaryMode;
  /** 作家タイプ診断結果のシリアライズデータ */
  serializedResult?: string | null;
  /** 作成日時（ISO 8601文字列） */
  createdAt: string;
  /** 更新日時（ISO 8601文字列） */
  updatedAt: string;
}

/**
 * アシスタント猫の詳細情報
 * 個々のアシスタント猫の属性と設定を定義
 */
export interface AssistantCat {
  /** ユーザーID */
  userId: string;
  /** アシスタント猫のタイプ（16種類） */
  assistantCatType: AssistWriterType;
  /** アシスタント猫の表示名（デフォルト名またはユーザー設定のニックネーム） */
  name: string;
  /** 公式名称（例：プロフェッサー、マーケター） */
  officialName: string;
  /** 公式名称日本語（例：専門家、市場調査人） */
  officialNameJapanese: string;
  /** アシスタント猫の説明文 */
  description: string;
  /** グループコード（LA, LP, MA, MP） */
  group: AssistantCatGroup;
  /** グループ名（ひらめき、知性、感性、追求心） */
  groupName: string;
  /** 現在選択中かどうか */
  selected: boolean;
  /** 作家タイプと一致するか */
  isWriterType: boolean;
  /** シナジータイプか */
  isSynergyType: boolean;
  /** インパクトタイプか */
  isImpactType: boolean;
  /** ニックネーム設定後の猫の反応メッセージ */
  reactionAfterSetName: string;
  /** 作成日時（ISO 8601文字列） */
  createdAt: string;
  /** 更新日時（ISO 8601文字列） */
  updatedAt: string;
}

/**
 * アシスタント猫マスタ更新用入力型
 * アシスタント猫の切り替え時に使用
 */
export interface UpdateAssistantCatMasterInput {
  /** 選択するアシスタント猫タイプ */
  selectedType?: AssistWriterType;
  /** アシスタント猫の感想モード */
  feedbackManuscriptMode?: FeedbackManuscriptMode;
  /** アシスタント猫のあらすじモード */
  generateSummaryMode?: GenerateSummaryMode;
}

/**
 * アシスタント猫情報更新用入力型
 * ニックネーム変更時に使用
 */
export interface UpdateAssistantCatInput {
  /** 更新対象のアシスタント猫タイプ */
  assistantCatType: AssistWriterType;
  /** 新しい名前（ニックネーム） */
  name: string;
}
